export function transformKeysToCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(transformKeysToCamelCase);
    }

    if (obj && typeof obj === 'object' && Object.prototype.toString.call(obj) === '[object Object]') {
        return Object.entries(obj).reduce((acc, [key, value]) => {
            const newKey = key.charAt(0).toLowerCase() + key.slice(1);
            acc[newKey] = transformKeysToCamelCase(value);
            return acc;
        }, {});
    }

    return obj;
}
